import { useMemo } from 'react';
import type { SatelliteWebLandlordLeadManagementNextStepDto } from '@zg-rentals/ts-satellite-client';

// Actions returned by the BE are filtered out until configured here. To add a new action type:
// add its linkId constant and a handler param to SecondaryActionHandlers (e.g., onDecline),
// then register it in the useMemo below.
const APPROVAL_LINK_IDS = ['nextStepApprove', 'nextStepMarkApproved'] as const;

export type PairedSecondaryAction = {
  action: SatelliteWebLandlordLeadManagementNextStepDto;
  handler: () => void;
};

type SecondaryActionHandlers = {
  onApprove?: () => void;
};

export default function useLeadManagementSecondaryActions(
  nextStepSecondaryActions: Array<SatelliteWebLandlordLeadManagementNextStepDto> | undefined | null,
  { onApprove }: SecondaryActionHandlers,
) {
  return useMemo(() => {
    if (!nextStepSecondaryActions) return [];

    const handlers: Record<string, () => void> = {};

    if (onApprove) {
      for (const id of APPROVAL_LINK_IDS) handlers[id] = onApprove;
    }

    return nextStepSecondaryActions
      .filter((action) => action.link.linkId in handlers)
      .map((action) => ({ action, handler: handlers[action.link.linkId] }));
  }, [onApprove, nextStepSecondaryActions]);
}
